import React from 'react';
import { Helmet } from 'react-helmet-async';
const CancellationPage = () => {
  return <div className="bg-white" data-id="element-1119">
      <Helmet data-id="element-1120">
        <title data-id="element-1121">
          Driving Lesson Policies Northampton | Cancellations, Health & Safety
        </title>
        <meta name="description" content="Read Northampton Driving School's policies on bookings, cancellations, health, and safety. Clear, fair, and transparent for every pupil." data-id="element-1122" />
        <meta name="keywords" content="driving lesson cancellation policy, Northampton driving school refunds, driving lesson booking terms, DVSA cancellation policy Northampton, driving test refund terms, health and safety policy" data-id="element-1123" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1124">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1125">
          Cancellation, Health & Safety Policy
        </h1>
        <p className="mb-6" data-id="element-1126">
          At <span className="text-burgundy-600" data-id="element-1127">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1128">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1129">S</span>chool, we understand that
          circumstances can change. However, to maintain a fair and efficient
          service for all our students, we have implemented the following
          cancellation, health, and safety policy:
        </p>
        <section className="mb-8" data-id="element-1130">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1131">
            Cancellation Notice Requirements
          </h2>
          <p className="mb-4" data-id="element-1132">
            Northampton Driving School requires 48 hours' notice to cancel or
            reschedule any lesson. This applies to all payments — card, cash, or
            advance online payment. Lessons cancelled with less than 48 hours'
            notice may be charged in full.
          </p>
        </section>
        <section className="mb-8" data-id="element-1133">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1134">
            Standard Lessons
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1135">
            <li data-id="element-1136">
              <strong data-id="element-1137">48+ Hours Notice:</strong> No charge will be applied if
              you cancel or reschedule with at least 48 hours' notice.
            </li>
            <li data-id="element-1138">
              <strong data-id="element-1139">24-48 Hours Notice:</strong> 50% of the lesson fee will be
              charged if you cancel or reschedule with between 24 and 48 hours'
              notice.
            </li>
            <li data-id="element-1140">
              <strong data-id="element-1141">Less than 24 Hours Notice:</strong> The full lesson fee
              will be charged if you cancel or reschedule with less than 24
              hours' notice.
            </li>
            <li data-id="element-1142">
              <strong data-id="element-1143">No Show:</strong> If you fail to attend a scheduled lesson
              without any prior notice, the full lesson fee will be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1144">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1145">
            Health and Safety Policy
          </h2>
          <p className="mb-4" data-id="element-1146">
            To protect other pupils and the instructor, please do not attend if
            you are unwell. If you attend with obvious cold/flu/cough symptoms
            you may be asked to leave and the lesson may still be chargeable.
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1147">
            <li data-id="element-1148">
              If you or anyone in your household is unwell, please cancel your
              lesson to avoid spreading illness.
            </li>
            <li data-id="element-1149">
              Pupils who arrive with cough/cold symptoms may be asked to end the
              lesson to protect other learners.
            </li>
            <li data-id="element-1150">
              Please maintain good personal hygiene so the car remains a
              pleasant, professional learning environment.
            </li>
            <li data-id="element-1151">
              The instructor reserves the right to end a lesson early if health
              and safety concerns arise.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1152">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1153">
            Intensive Courses
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1154">
            <li data-id="element-1155">
              <strong data-id="element-1156">7+ Days Notice:</strong> Full refund less a £50
              administration fee.
            </li>
            <li data-id="element-1157">
              <strong data-id="element-1158">3-7 Days Notice:</strong> 50% of the course fee will be
              retained.
            </li>
            <li data-id="element-1159">
              <strong data-id="element-1160">Less than 3 Days Notice:</strong> No refund will be
              provided.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1161">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1162">
            Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1163">
            <li data-id="element-1164">
              <strong data-id="element-1165">Test Booking Service:</strong> Our £110 test booking
              service (which includes the DVSA test fee of £62) is
              non-refundable once the test has been booked. Cancellation charges
              apply as per DVSA policy.
            </li>
            <li data-id="element-1166">
              <strong data-id="element-1167">Test Day Cancellation:</strong> If you cancel the use of
              the instructor's car for your test with less than 3 working days'
              notice, the full fee will still be charged.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1168">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1169">
            Driving Test Cancellation Policy
          </h2>
          <p className="mb-4" data-id="element-1170">
            Northampton Driving School is not responsible for refunds if the
            DVSA cancels, postpones, or changes a pupil's test date. The £110
            administrative fee is non-refundable once the booking has been made.
            Pupils must contact the DVSA directly to rebook or manage their
            driving test appointments.
          </p>
        </section>
        <section className="mb-8" data-id="element-1171">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1172">
            Exceptional Circumstances
          </h2>
          <p data-id="element-1173">
            We understand that exceptional circumstances such as illness,
            emergencies, or bereavement may arise. In such cases, please contact
            us as soon as possible, and we will do our best to accommodate your
            situation. Supporting documentation may be requested.
          </p>
        </section>
        <section className="mb-8" data-id="element-1174">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1175">
            Instructor Cancellations
          </h2>
          <p className="mb-4" data-id="element-1176">
            In the rare event that your instructor needs to cancel a lesson, we
            will:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1177">
            <li data-id="element-1178">Notify you as soon as possible</li>
            <li data-id="element-1179">Offer an alternative date and time</li>
            <li data-id="element-1180">
              If no suitable alternative can be found, provide a full refund for
              that lesson
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1181">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1182">
            Weather Conditions
          </h2>
          <p className="mb-4" data-id="element-1183">
            For safety reasons, lessons may need to be cancelled due to severe
            weather conditions (e.g., heavy snow, ice, fog, or flooding). In
            such cases:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1184">
            <li data-id="element-1185">
              The instructor will make the final decision based on safety
              considerations
            </li>
            <li data-id="element-1186">No cancellation fee will be charged</li>
            <li data-id="element-1187">
              We will work with you to reschedule the lesson as soon as possible
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1188">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1189">
            Payment and Refunds
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1190">
            <li data-id="element-1191">
              Refunds for eligible cancellations will be processed within 10
              working days
            </li>
            <li data-id="element-1192">
              Refunds will be made using the same payment method used for the
              original transaction
            </li>
            <li data-id="element-1193">
              Block booking discounts may be adjusted if cancellations reduce
              the number of lessons below the threshold for the discount
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1194">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1195">
            Contact Us
          </h2>
          <p className="mb-4" data-id="element-1196">
            If you need to cancel or reschedule a lesson, please contact us as
            soon as possible:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1197">
            <li data-id="element-1198">Phone: 07481 300 600</li>
            <li data-id="element-1199">Email: info@northamptondrivingschool.co.uk</li>
          </ul>
        </section>
        <p data-id="element-1200">
          This cancellation policy is effective from January 1, 2023, and may be
          subject to change. Any changes will be communicated to existing
          students and updated on our website.
        </p>
      </div>
    </div>;
};
export default CancellationPage;